export default {
  modelName: 'module_page',
  label: '模組頁面管理',
  fields: {
    id: {
      type: 'text',
      label: 'ID',
      readonly: true,
    },
    name: {
      type: 'text',
      label: '名稱',
      rules: 'required',
      maxlength: 100,
    },
    module: {
      type: 'text',
      label: 'module',
    },
    value: {
      label: 'value',
      type: 'text',
      rules: 'required',
    },
    pattern: {
      label: 'pattern',
      type: 'textarea',
      rules: 'required',
      autoGrow: true,
      getText: (value) => {
        return JSON.stringify(value);
      },
      setUpdateData: (value) => {
        return JSON.stringify(value);
      }
    },
    app_route: {
      type: 'text',
      label: 'app_route',
    },
    app_params: {
      type: 'textarea',
      label: 'app_params',
      autoGrow: true,
      getText: (value) => {
        return JSON.stringify(value);
      },
      setUpdateData: (value) => {
        return JSON.stringify(value);
      }
    },
    updated_at: {
      type: 'datetime',
      label: '更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
  },
};